import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Activities',
      value: stats?.total || 0,
      icon: 'Activity',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'Today',
      value: stats?.today || 0,
      icon: 'Calendar',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      title: 'Most Active Module',
      value: getMostActive(stats?.byModule),
      icon: 'TrendingUp',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      title: 'Most Common Action',
      value: getMostActive(stats?.byAction),
      icon: 'Zap',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-white rounded-lg border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.title}</p>
              <p className="text-2xl font-bold text-gray-900">{stat?.value}</p>
            </div>
            <div className={`${stat?.bgColor} p-3 rounded-lg`}>
              <Icon name={stat?.icon} className={`w-6 h-6 ${stat?.color}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

function getMostActive(obj) {
  if (!obj || Object.keys(obj)?.length === 0) return 'N/A';
  
  const entries = Object.entries(obj);
  const max = entries?.reduce((prev, current) => 
    current?.[1] > prev?.[1] ? current : prev
  );
  
  return max?.[0]?.replace(/_/g, ' ')?.replace(/\b\w/g, l => l?.toUpperCase());
}

export default ActivityStats;